import { render, staticRenderFns } from "./DeleteItemButton.vue?vue&type=template&id=5a399f95&scoped=true&"
import script from "./DeleteItemButton.vue?vue&type=script&lang=js&"
export * from "./DeleteItemButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItemButton.vue?vue&type=style&index=0&id=5a399f95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a399f95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a399f95')) {
      api.createRecord('5a399f95', component.options)
    } else {
      api.reload('5a399f95', component.options)
    }
    module.hot.accept("./DeleteItemButton.vue?vue&type=template&id=5a399f95&scoped=true&", function () {
      api.rerender('5a399f95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/buttons/DeleteItemButton.vue"
export default component.exports